import type { FAQPolicyValues } from "../faq-data.ts";
import type { FaqBuilder } from "./index.ts";

const buildFaqsEs: FaqBuilder = (p: FAQPolicyValues, fmt) => {
  const secondaryLine =
    p.secondaryCountryName && p.secondaryFreeAbove
      ? ` En Bélgica el envío es gratuito a partir de ${fmt.eur(p.secondaryFreeAbove)} EUR.`
      : "";
  return [
    {
      category: "Productos y alergias",
      items: [
        {
          q: "Tengo una alergia, ¿son aptos los productos de Unity Cosmetics?",
          a: "En casi todos los casos, nuestros productos son aptos. Envíanos un email con tu alergia específica y te asesoraremos personalmente sobre qué productos son seguros para ti. También puedes pedir primero una muestra para probar el producto en una pequeña zona de piel.",
        },
        {
          q: "¿Qué significa hipoalergénico?",
          a: "Hipoalergénico significa que la probabilidad de una reacción alérgica es extremadamente baja. Todos los productos de Unity Cosmetics son hipoalergénicos. Elegimos deliberadamente ingredientes que conllevan el menor riesgo posible de irritación.",
        },
        {
          q: "¿Cómo puedo comprobar si un producto es apto para mí?",
          a: "Te recomendamos probar primero el producto en una zona de piel en la parte interior del codo. Si tienes hipersensibilidad o una reacción alérgica, esto suele manifestarse dentro de las 24 horas en forma de picor, ligero enrojecimiento y, a veces, pequeños granitos. Hay muestras disponibles para la mayoría de los productos.",
        },
        {
          q: "¿Los productos de Unity Cosmetics son veganos?",
          a: "Gran parte de nuestra gama es vegana. En la página del producto, junto a las clasificaciones, se indica si el producto es vegano. Todos los productos están libres de pruebas en animales.",
        },
        {
          q: "¿Los productos de Unity Cosmetics contienen gluten?",
          a: "Todos nuestros productos están libres de gluten. Esto también se indica en las clasificaciones de la página del producto.",
        },
      ],
    },
    {
      category: "Pedidos y pagos",
      items: [
        {
          q: "¿Qué métodos de pago acepta Unity Cosmetics?",
          a: "Aceptamos iDEAL, Visa, Mastercard, PayPal, Klarna (paga después), Bancontact y transferencia SEPA.",
        },
        {
          q: "¿Cuándo recibiré mi pedido?",
          a: `Los pedidos se entregan en ${fmt.deliveryWindow} a través de ${p.carrier} con seguimiento (Track & Trace). Recibirás un email de confirmación con el código de seguimiento en cuanto se envíe tu paquete.`,
        },
        {
          q: "¿Hay envío gratuito?",
          a: `Sí, en pedidos dentro de los Países Bajos a partir de ${fmt.eur(p.primaryFreeAbove)} EUR el envío es gratuito.${secondaryLine}`,
        },
        {
          q: "¿Puedo pedir también muestras?",
          a: "Sí, hay muestras disponibles para la mayoría de los productos. Así puedes probar el producto en tu piel antes de comprar el tamaño completo.",
        },
      ],
    },
    {
      category: "Devoluciones",
      items: [
        {
          q: "¿Puedo devolver un producto?",
          a: `Tienes ${p.returnWindowDays} días de reflexión tras la recepción de tu pedido. Los productos deben devolverse sin abrir y en su embalaje original. Los gastos de devolución corren por tu cuenta (aprox. ${fmt.eur(p.returnCost)} EUR).`,
        },
        {
          q: "¿Qué pasa si tengo una reacción alérgica?",
          a: "Ponte en contacto con nosotros de inmediato. Aunque la probabilidad con nuestros productos es extremadamente baja, nos tomamos en serio cualquier reacción. Te ayudaremos a encontrar una solución adecuada.",
        },
      ],
    },
  ];
};

export default buildFaqsEs;
